import React from 'react'
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaPlane } from "react-icons/fa";
import { profile } from "../../constants";
import SocialIcons from "../layouts/SocialIcons";

const ContactRow = ({ icon, label, children }) => (
  <div className="flex items-center gap-4">
    <span className="shrink-0 w-12 h-12 rounded-xl bg-designColor/10 text-designColor inline-flex items-center justify-center">
      {icon}
    </span>
    <div className="min-w-0">
      <p className="text-xs uppercase tracking-wider text-gray-500">{label}</p>
      <div className="text-gray-200 break-all">{children}</div>
    </div>
  </div>
);

const ContactLeft = () => {
  return (
    <div className="card w-full lgl:w-[38%] h-full p-6 lgl:p-10 flex flex-col gap-8 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-60 h-60 rounded-full bg-designColor/15 blur-3xl"></div>
      <div className="relative flex flex-col gap-4">
        {profile.availability && (
          <span className="self-start chip text-green-300 border-green-400/30 bg-green-400/10">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse shrink-0"></span>
            Open to new roles
          </span>
        )}
        <h3 className="text-3xl font-bold text-white font-titleFont">Hiring for a high-impact role?</h3>
        <p className="text-base text-gray-400 leading-7">
          I'm exploring Forward Deployed, Solutions Engineering and Tech Lead roles — onsite or international. Drop me a message and I'll get back to you quickly.
        </p>
      </div>
      <div className="relative flex flex-col gap-5">
        <ContactRow icon={<FaEnvelope />} label="Email">
          <a href={`mailto:${profile.email}`} className="hover:text-designColor duration-300">{profile.email}</a>
        </ContactRow>
        <ContactRow icon={<FaPhoneAlt />} label="Phone">
          <a href={`tel:${profile.phone.replace(/\s/g, "")}`} className="hover:text-designColor duration-300">{profile.phone}</a>
        </ContactRow>
        <ContactRow icon={<FaMapMarkerAlt />} label="Location">
          {profile.location}
        </ContactRow>
        <ContactRow icon={<FaPlane />} label="Relocation">
          {profile.relocation}
        </ContactRow>
      </div>
      <div className="relative flex flex-col gap-4 mt-auto">
        <h2 className="text-xs uppercase tracking-[3px] text-gray-500">Find me on</h2>
        <SocialIcons />
      </div>
    </div>
  );
}

export default ContactLeft
